import Key from './Key'

export default Key
